/**
 * 新增比价地址
 */
export const PRICE_COMPARE_CREATE_PAGE_PATH = '/priceCompare/create'
